/**
 * Service: storage
 */
angular.module('acme.common.service.storage', [
  'LocalStorageModule'
])
.service('StorageService', [ 'localStorageService', function(localStorageService) {
    return localStorageService;
}]);